import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProductList from './ProductList.tsx';
import ProductFilters from './ProductFilters.tsx';



const  ProductListing= () => {
    return (
        <>
            <Row>
                <Col className="" xs={4} sm={4} md={3} lg={3} xl={2} style={{ backgroundColor: '#fff' }}>
                    <ProductFilters/>
                </Col>
                <Col className="" xs={8} sm={8} md={9} lg={9} xl={10}>
                    <ProductList />
                </Col>
            </Row>
        </>
    )
}

export default ProductListing